import clientConfig from './config';
import { PROD_DOMAIN, PUBLIC_BETA_DOMAIN, DOMAIN_STAGE_MAPPING } from './constants';
import { ClientConfig, ConfigOptions, Stage } from './types';

/**
 * Gets the stage from the window hostname.
 * Stage must be at the beginning of the hostname.
 *
 * @returns Stage name (ie. 'Beta')
 */
export const getStage = (): Stage => {
  const hostname = window?.location?.hostname;

  if (hostname === PROD_DOMAIN) {
    return Stage.PROD;
  }

  if (hostname === PUBLIC_BETA_DOMAIN) {
    return Stage.GAMMA;
  }

  for (const stage of Object.values(Stage)) {
    if (hostname?.includes(DOMAIN_STAGE_MAPPING[stage])) {
      return stage;
    }
  }

  return Stage.DEV;
};

/**
 * Gets the config for the provided key
 *
 * @param configKey Key that determines which part of the config is returned
 * @param opts Options for retrieving the config. Currently only stage is available as an option
 * @returns A config object
 */
export const getConfig = <K extends keyof ClientConfig>(configKey: K, opts?: ConfigOptions): ClientConfig[K] => {
  if (!(configKey in clientConfig)) {
    throw new Error('Unknown configuration key');
  }

  const stage = opts?.stage ?? getStage();

  return clientConfig[configKey]?.[stage];
};
